/**
 * Areas Catalog Mapper
 */

import type { LC_AreaItem, Area } from './areas.types.ts';

/**
 * Map LC_AreaItem to Area
 */
export function mapAreaOutToModel(item: LC_AreaItem): Area {
  return {
    id: item.areaId,
    name: item.area,
  };
}
